import OrganisationTypeEnum from '@constants/enums/organisation/type';

import NomineeApi from '@packages/nominees/api';

import { Organisation } from '@/models';

export class Nominee extends Organisation {
    static name = 'Nominee';
    static entity = 'nominees';
    static Api = NomineeApi;

    static fields() {
        return {
            ...super.fields(),
            type: this.enum(OrganisationTypeEnum, OrganisationTypeEnum.NOMINEE).nullable()
        };
    }
}

export default Nominee;
